<template>
  <div @click="selectLevel" :class="['uk-card', 'uk-margin-right', 'uk-margin-left', 'uk-card-body', {'uk-card-primary': isSelected, 'uk-card-hover': !isSelected, 'uk-card-default': !isSelected}]">
    <p><b>{{ $t("levels.level") }} {{ levelKey }}</b></p>
    <p v-if="!defaultCustom">{{ $t("levels.contains")}}: {{ levels[levelKey].length }}</p>
    <p v-if="!defaultCustom">{{ $t("levels.example")}}: {{ levelExample }}</p>
    <button class="uk-button uk-button-primary" v-if="isCustom" uk-toggle="target: #modal-example">{{ $t("buttons.configure")}}</button>
    <configuration v-if="isCustom"></configuration>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import Configuration from "./Configuration.vue"

  export default {
    props: ["levelKey"],
    computed: {
      ...mapGetters(["levels", "selectedLevel", "language", "ownLevelSet"]),
      isSelected() {
        return this.selectedLevel === this.levelKey;
      },
      levelExample() {
        let method = this.language == "en" ? "name" : "name_cs";
        return this.levels[this.levelKey].slice(0,3).map(b => b[method]).join(", ")
      },
      defaultCustom() {
        return this.isCustom && !this.ownLevelSet;
      },
      isCustom() {
        return this.levelKey === "X";
      }
    },
    methods: {
      selectLevel: function() {
        this.$store.dispatch("selectLevel", this.levelKey);
      }
    },
    components: {
      configuration: Configuration
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Level.vue